export enum EFactEAttestEnum {
  EFact,
  EAttest,
}

export const translateKey = (value: string): string => {
  return "eFacteAttest." + value.toLowerCase();
};

export const allEFactEAttest = () => {
  return [EFactEAttestEnum.EFact, EFactEAttestEnum.EAttest];
};
